export const Badge = ({ children, variant = "blue" }) => {
  const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");

  const isRetailerMobile =
    window.innerWidth < 640 && authUser?.role === 5;

  const map = {
    blue: {
      normal: "bg-blue-50 text-blue-700 border-blue-200",
      glass: "bg-blue-400/20 text-blue-900 border-blue-400/30",
    },
    info: {
      normal: "bg-blue-50 text-blue-700 border-blue-200",
      glass: "bg-blue-400/20 text-blue-900 border-blue-400/30",
    },
    success: {
      normal: "bg-emerald-50 text-emerald-700 border-emerald-200",
      glass: "bg-emerald-400/20 text-emerald-900 border-emerald-400/30",
    },
    warning: {
      normal: "bg-amber-50 text-amber-700 border-amber-200",
      glass: "bg-amber-400/20 text-amber-900 border-amber-400/30",
    },
    danger: {
      normal: "bg-rose-50 text-rose-700 border-rose-200",
      glass: "bg-rose-400/20 text-rose-900 border-rose-400/30",
    },
    green: {
      normal: "bg-emerald-50 text-emerald-700 border-emerald-200",
      glass: "bg-emerald-400/20 text-emerald-900 border-emerald-400/30",
    },
    yellow: {
      normal: "bg-amber-50 text-amber-700 border-amber-200",
      glass: "bg-amber-400/20 text-amber-900 border-amber-400/30",
    },
    red: {
      normal: "bg-rose-50 text-rose-700 border-rose-200",
      glass: "bg-rose-400/20 text-rose-900 border-rose-400/30",
    },
    gray: {
      normal: "bg-slate-100 text-slate-700 border-slate-200",
      glass: "bg-white/20 text-slate-900 border-white/30",
    },
  };

  const styles = map[variant] || map.blue;

  return (
    <span
      className={`
        inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold border transition-all duration-300
        ${
          isRetailerMobile
            ? `backdrop-blur-md shadow-sm ${styles.glass}`
            : styles.normal
        }
      `}
    >
      {children}
    </span>
  );
};


// export const Badge = ({ children, variant = "blue" }) => {
//   const map = {
//     blue: "bg-blue-50 text-blue-700 border-blue-200",
//     info: "bg-blue-50 text-blue-700 border-blue-200", // ✅ ADD THIS

//     success: "bg-emerald-50 text-emerald-700 border-emerald-200",
//     warning: "bg-amber-50 text-amber-700 border-amber-200",
//     danger: "bg-rose-50 text-rose-700 border-rose-200",

//     green: "bg-emerald-50 text-emerald-700 border-emerald-200",
//     yellow: "bg-amber-50 text-amber-700 border-amber-200",
//     red: "bg-rose-50 text-rose-700 border-rose-200",
//     gray: "bg-slate-100 text-slate-700 border-slate-200",
//   };

//   return (
//     <span
//       className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${
//         map[variant] || map.blue   // ✅ fallback safety
//       }`}
//     >
//       {children}
//     </span>
//   );
// };




// import React from "react";

// export const Badge = ({ children, variant = "blue" }) => {
//   const map = {
//     blue: "bg-blue-50 text-blue-700 border-blue-200",

//     // ✔ Add support for your variants
//     success: "bg-emerald-50 text-emerald-700 border-emerald-200",
//     warning: "bg-amber-50 text-amber-700 border-amber-200",
//     danger: "bg-rose-50 text-rose-700 border-rose-200",

//     // Old names (optional fallback)
//     green: "bg-emerald-50 text-emerald-700 border-emerald-200",
//     yellow: "bg-amber-50 text-amber-700 border-amber-200",
//     red: "bg-rose-50 text-rose-700 border-rose-200",
//     gray: "bg-slate-100 text-slate-700 border-slate-200",
//   };

//   return (
//     <span
//       className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${map[variant]}`}
//     >
//       {children}
//     </span>
//   );
// };




// import react from "react";
// export const Badge = ({ children, color = "blue" }) => {
//   const map = {
//     blue: "bg-blue-50 text-blue-700 border-blue-200",
//     green: "bg-emerald-50 text-emerald-700 border-emerald-200",
//     red: "bg-rose-50 text-rose-700 border-rose-200",
//     yellow: "bg-amber-50 text-amber-700 border-amber-200",
//     gray: "bg-slate-100 text-slate-700 border-slate-200",
//   };
//   return (
//     <span
//       className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${map[color]}`}
//     >
//       {children}
//     </span>
//   );
// };